export { default } from './store-information.component';
